<div class="chart-container" [class.expanded]="expanded" [class.monitor]="isMonitorMode">
  <div *ngIf="loading" style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }" style="width: 100%;"></nz-skeleton>
  </div>
  <canvas *ngIf="!loading" baseChart [data]="barChartData" [options]="barChartOptions" [type]="barChartType" [legend]="barChartLegend"
    [plugins]="barChartPlugins"></canvas>
</div>